import { SlashCommand } from './types';

export const pdfToolsCommands: SlashCommand[] = [
    {
        id: 'pdf-convertjpg',
        trigger: '/convertjpg',
        name: 'Convert PDF to JPG',
        description: 'Convert an attached PDF into JPG images',
        category: 'MEDIA',
        icon: 'fas fa-file-image',
        mode: 'prompt',
        integration: 'PDF Tools'
    },
    {
        id: 'pdf-convertpng',
        trigger: '/convertpng',
        name: 'Convert PDF to PNG',
        description: 'Convert an attached PDF into PNG images',
        category: 'MEDIA',
        icon: 'fas fa-file-image',
        mode: 'prompt',
        integration: 'PDF Tools'
    },
    {
        id: 'pdf-compress',
        trigger: '/compress',
        name: 'Compress PDF',
        description: 'Compress an attached PDF to reduce file size',
        category: 'MEDIA',
        icon: 'fas fa-compress',
        mode: 'prompt',
        integration: 'PDF Tools'
    }
];
